import { Component, OnInit, AfterContentInit } from '@angular/core';

import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IrregularidadeService } from 'src/app/pages/cadastros/irregularidade/irregularidade.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';

@Component({
  selector: 'app-irregularidade',
  templateUrl: './irregularidade.component.html',
  providers: [IrregularidadeService]
})
export class IrregularidadeComponent implements OnInit, AfterContentInit {


  public cadastrados: any[] = [];

  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;


  public filtredByTipo = 0;
  public filtredByParameter = '';


  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes = null;

  constructor(
    private irregularidadeService: IrregularidadeService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService
  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('irregularidade');
  }

  ngOnInit() {

   this.search(this.filtredByParameter, this.filtredByTipo, true);
   this.resetForm();

  }


  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        descricao: new FormControl(null, Validators.required),
        descricaoAbreviada: new FormControl('', [Validators.required, Validators.maxLength(19)]),
        classificacao: new FormControl('', Validators.required),
      }
    );
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;

    this.resetForm();
  }

  public read(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.irregularidadeService.read(id).subscribe(

      (response: any) => {

        this.form.get('id').setValue(response.id);
        this.form.get('descricao').setValue(response.descricao);
        this.form.get('descricaoAbreviada').setValue(response.descricaoAbreviada);
        this.form.get('classificacao').setValue(response.classificacao);
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

      this.isProcessing = true;
      const id = this.form.get('id').value;

      this.irregularidadeService.isUniqueDescricaoIrregularidade(this.form.get('descricao').value, id).subscribe(

        (isUniqueDescricaoIrregularidade: boolean) => {

          if (isUniqueDescricaoIrregularidade) {

            this.irregularidadeService.isUniqueDescricaoAbreviadaIrregularidade(this.form.get('descricaoAbreviada').value, id).subscribe(
              (isUniqueDescricaoAbreviadaIrregularidade: boolean) => {
                if (isUniqueDescricaoAbreviadaIrregularidade) {
                  this.save();
                } else
                {
                  this.form.get('descricaoAbreviada').setErrors({ isNotUniqueDescricaoAbreviadaIrregularidade: true });
                  this.isProcessing = false;
                }
              })

          } else {
            this.form.get('descricao').setErrors({ isNotUniqueDescricaoIrregularidade: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
     



  }


  public save() {

    this.irregularidadeService.create(this.form.value).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.search(this.filtredByParameter, this.filtredByTipo, true);
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.irregularidadeService.delete(id).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.search(this.filtredByParameter, this.filtredByTipo, true);
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }



  search(parametro: string, tipoLocal: number, isSaving: boolean = false) {

    this.filtredByParameter = parametro;

    if (parametro === '') { parametro = null; }

    if (tipoLocal > 0) {
      if (tipoLocal === this.filtredByTipo) {
        if (isSaving === false) { this.filtredByTipo = 0; }
      } else {
        this.filtredByTipo = tipoLocal;
      }
    }


    this.isLoading = true;

    this.irregularidadeService.search(parametro, this.filtredByTipo).subscribe(response => {
      this.cadastrados = response;
      this.setVoids();
      this.isFiltered = !(this.filtredByParameter === '' && tipoLocal === 0);
      this.isLoading = false;
    });
  }

  clearSearch() {
    ( document.getElementById('parametro') as HTMLInputElement).value = '';

    this.filtredByTipo = 0;
    this.filtredByParameter = '';
    this.search(this.filtredByParameter, this.filtredByTipo);
    this.isFiltered = false;
  }

  updateDescricaoAbreviada(){

    if (this.form.get('descricaoAbreviada').value == '')
    {
      const descricao = this.form.get('descricao').value;
      if (descricao.length <= 25) {
        this.form.get('descricaoAbreviada').setValue(descricao);
      }
    }
}

}
